import { Component } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AccountService, TestService } from "../../../api/services";
import { GlobalApp } from "../../../tools/global";
import { LoginLocal } from "../../../api/models";
import { ForgotPasswordService } from "../../../api/services/forgot-password.service";

@Component({
  selector: "account-login",
  templateUrl: "./account-login.component.html",
})
export class AccountLoginComponent {
  public emailAddress: string = "";
  public password: string = "";
  public errorMessage: string = "";
  public forgotPasswordFlag: boolean = false;
  public resendFlag: boolean = false;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private globalApp: GlobalApp,
    private forgotPasswordService: ForgotPasswordService
  ) {}

  ngOnDestroy() {}

  loginUser() {
    this.errorMessage = "";

    var loginLocalParams: LoginLocal = {
      email: this.emailAddress,
      password: this.password,
    };

    this.accountService.accountLoginLocal(loginLocalParams).subscribe(
      (result) => {
        if (result == null) {
          this.errorMessage = "Invalid Credentials";
        } else {
          if (result.loginStatus != 1) {
            this.errorMessage = result.errorMessage;

            if (result.loginStatus == -3) {
              this.resendFlag = true;
            }
          } else if ((result.loginStatus = 1)) {
            const jwtResult = JSON.parse(result.jwtToken);
            this.globalApp.logIn(
              jwtResult.id,
              jwtResult.auth_token,
              result.isAdmin,
              this.emailAddress
            );
            this.router.navigate(["/"]);
          }
        }
      },
      (error) => {
        this.errorMessage = "Critical Error, Contact Support";
      }
    );
  }

  forgotPassword() {
    this.forgotPasswordFlag = true;
  }

  sendResetPassword() {
    if (this.emailAddress !== "") {
      this.forgotPasswordService
        .forgotPasswordSendForgotPasswordLink(this.emailAddress)
        .subscribe((result) => {
          this.errorMessage =
            "If your email address was found, a reset email will arrive in your inbox shortly.  If the email does not appear, check your junk folder.";
        });
    } else {
      this.errorMessage = "Email address required.";
    }
  }

  cancelResetPassword() {
    this.forgotPasswordFlag = false;
  }

  resendEmailVerification() {
    var params: LoginLocal = {
      email: this.emailAddress,
      password: "",
    };

    this.accountService
      .accountResendVerification(params)
      .subscribe((result) => {
        if (result) {
          this.errorMessage =
            "Verification email sent, make sure you check your junk folder.";
          this.resendFlag = false;
        } else {
          this.errorMessage = "Failed to resend email, please contact support.";
          this.resendFlag = false;
        }
      });
  }
}
